import { Reveal } from "@/components/Reveal";
import { SafeImage } from "@/components/SafeImage";

export const Banner = () => (
  <section data-testid="banner-section" className="relative overflow-hidden border-y border-white/10">
    <SafeImage
      src="/assets/banner-alturas.png"
      alt="Equipe KRONO em altura pintando fachada"
      label="Banner institucional em geração"
      className="absolute inset-0 h-full w-full object-cover opacity-40"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/30" />
    <div className="relative mx-auto max-w-7xl px-6 py-28 md:py-40">
      <Reveal>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Manifesto ]</p>
        <h2 className="max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl">
          Transformamos <span className="text-krono">alturas</span> em orgulho.
        </h2>
      </Reveal>
    </div>
  </section>
);
